module.exports = __webpack_public_path__ + "img/59.5.COD.1e1ca4cd.png";